import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpProduct', pkpProduct);

    /**
     * @author sosoehng.prv
     * @ngInject
     */
    function pkpProduct() {
        return {
            restrict: 'E',
            scope: {
                nwp: '='
            },
            template: require('app/_directives/pkp-product.directive.html')
        };
    }
})();
